<template>
  <div>

    <title-row
      title="Hozzáférési szintek"
      :subtitle="dataTable.itemsLength === -1
        ? 'Betöltés...'
        : `${dataTable.itemsLength} hozzáférési szint van a rendszerben`
      "
      :breadcrumb-items="[
        {
          text: 'Hozzáférési szintek',
          disabled: true,
        },
      ]">
      <template #buttons>
        <title-row-button v-if="hasRight('ACCESS_LEVEL_WRITE')" :to="{ name: 'NewAccessLevel' }" title="Hozzáadás">
          <v-icon left>mdi-plus</v-icon>
          Új hozzáférési szint
        </title-row-button>
      </template>
    </title-row>

    <v-expansion-panels
      class="mb-4 rounded-xl overflow-hidden"
      :mandatory="!!Object.values(search).find((e) => e !== '')"
      flat>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="font-weight-medium">
            <v-icon left>mdi-magnify</v-icon>
            Keresés
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mt-2">
            <v-col :cols="12" :sm="4" :md="3">
              <v-text-field
                v-model="search.name"
                @input="searchEventHandler"
                label="Megnevezés"
                clearable
                hide-details
                filled />
            </v-col>
            <v-col :cols="12" :sm="4" :md="3">
              <v-autocomplete
                label="Csoport"
                :items="groups"
                item-text="name"
                item-value="element_id"
                v-model="search.group_id"
                hide-details
                clearable
                @change="searchEventHandler"
                @click:clear="searchEventHandler"
                filled />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card class="rounded-xl" flat>
      <v-data-table
        :loading="loading"
        :headers="dataTable.headers"
        :items="dataTable.items"
        :server-items-length="dataTable.itemsLength"
        :options.sync="dataTable.options"
        :footer-props="$config.dataTableFooterProps">
        <template #[`item.groups`]="{ item }">
          <v-chip
            link
            label
            small
            v-for="(group, index) of item.groups"
            :key="`group-${group.element_id}-${index}`"
            :to="{ name: 'GroupEditor', params: { id: group.element_id } }"
            class="ma-1 rounded-xl">
            {{ group.name }}
          </v-chip>
        </template>
        <template #[`item.actions`]="{ item }">
          <v-btn
            v-if="hasRight('ACCESS_LEVEL_WRITE')"
            text
            fab
            small
            dark
            color="primary"
            class="rounded-xl mr-1"
            :to="{ name: 'AccessLevelEditor', params: { id: item.element_id } }"
            title="Szerkesztés">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            v-if="hasRight('ACCESS_LEVEL_WRITE')"
            text
            fab
            small
            dark
            color="primary"
            class="rounded-xl mr-1"
            @click="deleteAccessLevel(item)"
            :disabled="!item.erasable"
            title="Törlés">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-btn
            v-if="(Number($store.state.user.superadmin)) && copyId == null"
            text
            fab
            small
            dark
            @click="copyId = item.element_id"
            color="primary"
            class="rounded-xl mr-1"
            title="Másolás">
            <v-icon>mdi-content-copy</v-icon>
          </v-btn>
          <v-btn
            v-else-if="(Number($store.state.user.superadmin)) && copyId == item.element_id"
            text
            fab
            small
            dark
            @click="copyId = null"
            color="primary"
            class="rounded-xl mr-1"
            title="Kilépés a másolásból">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn
            v-else-if="(Number($store.state.user.superadmin)) && copyId != item.element_id"
            text
            fab
            small
            dark
            @click="fetchAccessLevelAssets(item.element_id, copyId)"
            color="primary"
            class="rounded-xl mr-1"
            title="Beillesztés">
            <v-icon>mdi-content-paste</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import { dataTablePage } from '@/mixins';

export default {
  mixins: [dataTablePage],

  data() {
    return {
      routeName: 'AccessLevelList',
      fetchItems: this.fetchAccessLevels,
      dataTable: {
        options: {
          sortBy: ['name'],
        },
        headers: [
          { text: 'Megnevezés', value: 'name' },
          { text: 'Csoportok', value: 'groups', sortable: false },
          { text: '', value: 'actions', sortable: false, align: 'end' },
        ],
      },
      search: {
        name: '',
        group_id: 0,
      },
      groups: [],
      searchTimeout: null,
      copyId: null,
    };
  },

  mounted() {
    this.fetchAccessLevelGroups();
  },

  methods: {
    parseSearchQueries() {
      return {
        name: this.$route.query.name,
        group_id: this.$route.query.group_id,
      };
    },

    async deleteAccessLevel(item) {
      const confirm = await this.$dialog.confirm({
        type: 'error',
        text: `<b>${item.name}</b> hozzáférési szint törlésére készül! Folytatja?`,
        title: 'Figyelem',
      });

      if (confirm) {
        try {
          await this.$http.get(`access-levels/delete/${item.element_id}`);
          this.fetchAccessLevels();
        } catch (e) {
          console.error(error);
        } finally {
          this.loading = false;
        }
      }
    },

    async fetchAccessLevels() {
      this.loading = true;
      try {
        const response = await this.$http.post('access-levels/list', this.postData);
        this.dataTable.items = response.access_levels;
        this.dataTable.itemsLength = response.access_levels_count;
        this.dataTable.options.page = Number(this.$route.query.page) || 1;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    async fetchAccessLevelGroups() {
      this.loading = true;
      try {
        const response = await this.$http.post('groups/list', { group_type: 'ACCESS_LEVEL' });
        this.groups = [...this.groups, ...response.groups];
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    async fetchAccessLevelAssets(id, copyId) {
      const confirm = await this.$dialog.confirm({
        type: 'primary',
        text: `Hozzáférési szint felülírására készül! Folytatja?`,
        title: 'Figyelem',
      });

      if (confirm) {
        try {
          this.loading = true;
          try {
            const copyRes = await this.$http.get(
              `access-levels/details/${copyId}`
            );
            const pasteRes = await this.$http.get(
              `access-levels/details/${id}`
            );
            pasteRes.access_level.elements = copyRes.access_level.elements;
            const response = await this.$http.post('access-levels/save', pasteRes.access_level);
            if (this.lodash.size(response.errors) == 0) {
              this.$dialog.notify.success('Sikeres mentés');
            } else {
              this.$dialog.notify.error('Sikertelen mentés');
            }
          } catch (e) {
            console.error(e);
          } finally {
            this.loading = false;
          }
        } catch (e) {
          console.error(error);
        } finally {
          this.loading = false;
        }
      }
    },
  },

  computed: {
    searchQueries() {
      return {
        name: this.search.name || '',
        group_id: this.search.group_id || 0,
      };
    },
  },

  asyncComputed: {
    exportWorksheetOptions: {
      async get() {
        const r = await this.$http.get('access-levels/list');
        return r.access_levels;
      },
      default: [],
    },
  },
};
</script>
